'use strict';

document.addEventListener('DOMContentLoaded', () => {
    // safari is the new ie: https://www.w3.org/TR/2018/SPSD-html5-20180327/forms.html#implicit-submission
    const form = document.getElementById('videoconference-login');
    if (form != null) {
        form.querySelectorAll('button[type="submit"]').forEach((submitBtn) => {
            if (submitBtn.hasAttribute('disabled')) {
                form.addEventListener('submit', function (e) {
                    e.preventDefault();
                });
            }
        });
    }

    const login = document.getElementById('videoconference-join') ?? document.getElementById('videoconference-repair');
    if (login == null) {
        console.error('Received malformed form.');
        return;
    }

    fetch(login.dataset['auth'])
        .then((data) => data.json())
        .then((url) => {
            login.classList.add('hidden');

            // Link injected by JS async
            document.querySelector('#videoconference-link-injection').href = url;

            document.querySelector('.for-user').classList.remove('hidden');

            // Try to redirect directly
            window.setTimeout(() => {
                window.location = url;
            }, login.dataset['timer'] * 1000);
        })
        .catch(() => {
            login.classList.add('hidden');
            const guestPanel =
                document.getElementById('videoconference-join-guest') ??
                document.getElementById('videoconference-repair-guest');
            const guestInput = guestPanel.querySelector('input');
            if (guestInput != null) {
                guestInput.focus();
            }
            document.querySelector('.for-guest').classList.remove('hidden');
        });
});
